import React from 'react'
import SubmitButton from './SubmitButton'

export * from './SubmitButton'
export default React.memo(SubmitButton)
